module.exports = "<div class=\"wrapper\">\n  <nav id=\"sidebar\">\n    <ul class=\"list-unstyled components\">\n      <li routerLinkActive=\"active\"><a routerLink=\"scores\"><i class=\"zmdi zmdi-grid\"></i> Scores</a></li>\n      <li routerLinkActive=\"active\"><a routerLink=\"search\"><i class=\"zmdi zmdi-search\"></i> Search</a></li>\n    </ul>\n  </nav>\n\n  <div id=\"content\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/monitoring/monitoring.component.html
// module id = ./src/app/monitoring/monitoring.component.html
// module chunks = main